import React from 'react';

// Componente per l'icona/emblema puro
export const LogoMark = ({ className = "w-5 h-5" }) => {
  return (
    <img 
      src="/alkeon-pure.jpg" 
      alt="ALKEON Emblem" 
      className={`${className} object-contain rounded-sm inline-block`} 
    />
  );
};

// Componente Logo principale
export const Logo = ({ className = "h-10", variant = "pure" }) => {
  const logoSrc = variant === "full" ? "/alkeon-logo.jpg" : "/alkeon-pure.jpg";
  const altText = variant === "full" ? "ALKEON Timeless Design" : "ALKEON Emblem";

  return (
    <div className="flex items-center gap-3">
      <img 
        src={logoSrc} 
        alt={altText} 
        className={`${className} object-contain rounded-sm shadow-sm transition-opacity duration-300 hover:opacity-90`} 
      />
    </div>
  );
};

export default Logo;